import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/content";

type MediaCardProps = {
  item: MediaItem;
  rank?: number;
};

export default function MediaCard({ item, rank }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer"
      aria-label={`查看${item.title}详情`}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg border border-background-200 bg-primary-900">
        <img
          src={item.poster}
          alt={`${item.title}（${item.year}）影视海报`}
          title={`${item.title} - 天马传媒${item.type === "movie" ? "电影" : "电视剧"}`}
          className="h-full w-full object-cover object-top transition duration-700 group-hover:scale-[1.04]"
        />
        <div className="poster-mask absolute inset-0 opacity-90"></div>
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-2.5">
          <span className="flex items-center gap-1 rounded-md bg-primary-950/70 px-1.5 py-1 text-[11px] font-medium text-accent-300 backdrop-blur">
            <i className="ri-star-fill text-[11px]"></i>
            {item.rating.toFixed(1)}
          </span>
          <span className="rounded-md bg-background-50/90 px-1.5 py-1 text-[10px] tracking-wide text-primary-800">
            {item.type === "movie" ? "电影" : "剧集"}
          </span>
        </div>
        {typeof rank === "number" && (
          <div className="absolute -bottom-1 left-2 font-heading text-5xl font-bold leading-none text-background-50/90">
            {String(rank).padStart(2, "0")}
          </div>
        )}
        <div className="absolute inset-x-0 bottom-0 p-3">
          <p className="line-clamp-1 text-[11px] text-background-200/90">
            {item.genres.join(" / ")}
          </p>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="line-clamp-1 text-sm font-medium text-foreground-950 transition group-hover:text-primary-500 md:text-[15px]">
          {item.title}
        </h3>
        <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{item.year}</span>
          <span className="h-2.5 w-px bg-background-300"></span>
          <span>{item.region}</span>
          <span className="h-2.5 w-px bg-background-300"></span>
          <span className="line-clamp-1">{item.genres[0]}</span>
        </p>
      </div>
    </Link>
  );
}